"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketStepSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styled = require("../styled");
var _BasketItemSkeleton = require("./BasketItemSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
const QuickOrderFormWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex'
}));
const QuickOrderInputSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '100%',
  borderRadius: theme.spacing(5)
}));
const QuickOrderButtonSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  borderRadius: theme.spacing(5),
  marginLeft: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}));
const BasketStepSkeleton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.BasketCard, {
    "data-testid": getTestId('basket-step-skeleton'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(QuickOrderFormWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(QuickOrderInputSkeleton, {
        animation: "wave",
        variant: "rounded",
        height: 45
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(QuickOrderButtonSkeleton, {
        animation: "wave",
        variant: "rounded",
        height: 45,
        width: 150
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BasketItemSkeleton.BasketItemSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BasketItemSkeleton.BasketItemSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BasketItemSkeleton.BasketItemSkeleton, {})]
  });
};
exports.BasketStepSkeleton = BasketStepSkeleton;